export default __webpack_public_path__ + "static/media/apple_white.0641e511.svg";